module.exports = __webpack_public_path__ + "media/packs/images/flags/IT-ca7030a25da4b1dd616bdaebba5b0d3e.svg";